import { AxiosResponse } from "axios";
import store from "../store";
import { handleToastState } from "../slices/shared";

const axiosSuccessInterceptor = async (response: AxiosResponse) => {
  const { dispatch } = store;

  if (!!response.config.params?.successToast) {
    dispatch(handleToastState({ open: "success", message: "Success!" }));
  }

  return response;
};

export default axiosSuccessInterceptor;
